import { Base } from './Base.js';
export class Optional extends Base {
  constructor(type) {
    let condition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    super();
    this.type = type;
    this.condition = condition;
  }
  decode(stream, parent) {
    let condition = this.condition;
    if (typeof condition === 'function') {
      condition = condition.call(parent, parent);
    }
    if (condition) {
      return this.type.decode(stream, parent);
    }
  }
  size(val, parent) {
    let condition = this.condition;
    if (typeof condition === 'function') {
      condition = condition.call(parent, parent);
    }
    if (condition) {
      return this.type.size(val, parent);
    } else {
      return 0;
    }
  }
  encode(stream, val, parent) {
    let condition = this.condition;
    if (typeof condition === 'function') {
      condition = condition.call(parent, parent);
    }
    if (condition) {
      return this.type.encode(stream, val, parent);
    }
  }
}